<template>
  <v-navigation-drawer app v-model="drawer" :width="drawerWidth" class="partner-sidebar"> <!-- dark color="tertiary" -->
    <v-card tile flat :to="{ name: 'Partner' }" color="transparent" class="sidebar-header">
      <v-container class="pt-2 pb-0 px-0">
        <v-row justify="center" class="pb-1" no-gutters>
          <v-img src="/api2/Report/logo" height="52" max-width="110" contain :alt="userInfo.Provider.CompanyName"
            position="center">
          </v-img>
        </v-row>
        <v-row justify="center" class="py-1" style="background-color: rgb(0 0 0 / 3%);" no-gutters>
          {{ $t("partner.portal.title") }}
        </v-row>
      </v-container>
    </v-card>


    <v-divider />

    <v-list dense class="sidebar-nav py-0">
      <NavTileComponent v-for="item in items" :key="item.title" :route="item.route" :title="item.title"
        :icon="item.icon" :count="item.count">
      </NavTileComponent>
    </v-list>

    <v-row no-gutters class="sidebar-bottom">
      <v-col>
        <AccountButton />
        <v-card tile flat class="text-center py-1 powered-by" href="https://www.qwips.no" target="_blank">
          <small>Powered by <b>Qwips</b></small>
        </v-card>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>


<script>
import AccountButton from "@/components/AccountButton.vue";
import AuthStoreMixin from "@/helpers/mixins/AuthStoreMixin";
import NavTileComponent from "@/components/NavTileComponent.vue";

export default {
  name: "SideBar",
  props: {
    items: Array
  },
  mixins: [AuthStoreMixin],
  components: {
    AccountButton,
    NavTileComponent,
  },

  data() {
    return {
      drawer: true,
      drawerWidth: 130,
    };
  },

  mounted() { },

  methods: {},

  computed: {
    userInfo() {
      if (this.authUserInfo) return this.authUserInfo;
      return { Customer: {}, Provider: {} };
    },

    shoppingCartCount() {
      return this.shoppingCartItemCount;
    },

    openJobsCount() {
      return this.openJobsCountValue;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.partner-sidebar {
  border-right: 1px solid rgba(0, 0, 0, 0.08);
}

.sidebar-header {
  color: rgba(0, 0, 0, 0.82);
}

.sidebar-nav {
  padding-bottom: 112px !important;
}

.sidebar-bottom {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  z-index: 100;
}

.powered-by {
  background-color: rgba(0, 0, 0, 0.09) !important;
}

.powered-by small {
  font-weight: 400;
}
</style>